import React, { useState, useEffect, useRef } from 'react';
import { Button, Input, Select, message, Form, InputNumber, Col, Row, AutoComplete, Card, Spin, Radio } from 'antd';
import useWebPost from '../../utils/useWebPost';
import { getobjkeys, getJsfs } from '../../utils/functions';
import FullHeightLayout from '../../components/FullHeightLayout';
import { useNavigate, useParams } from 'react-router-dom';
import ImgUploader from "../../components/ImgUploader";
import DateInput from '../../components/DateInput';

const { Option } = Select;

const InvoiceForm = ({ myHt, myItem, fkey, onSave }) => {
    const [myHtv, setMyHtv] = useState(myHt);
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const webPost = useWebPost();
    const [step, setStep] = useState(0);
    const [isloading, setIsloading] = useState(false);
    const [config, setConfig] = useState({});
    const [xmsn, setXmsn] = useState('');
    const [kmdata, setKmdata] = useState([]);
    const [lyfresh, setLyfresh] = useState(1);
    const [lycount, setLycount] = useState(1);
    const [invoice_id, setInvoiceId] = useState(0);
    const [totalsj, setTotalsj] = useState(0);
    const [showFile1, setShowFile1] = useState(false);
    const [lydata, setLydata] = useState({ '个人来款': null, '建设单位来款': null, '资金垫付': null });
    const [lyfkzh, setLyfkzh] = useState({});
    useEffect(() => {
        async function getCs(sn) {
            setIsloading(true);
            try {
                const configs = await webPost('InvoiceConfig', { sn });
                setConfig({ ...configs, jsfs: getJsfs() });

                setLydata({
                    '个人来款': [...configs['个人来款'], { id: 0, make_date: '现付', kmmc: '现付', left_amount: 0 }], '建设单位来款': configs['建设单位来款'],
                    '资金垫付': configs['资金垫付'].length === 0 ? [{ id: 0, make_date: '资金垫付', kmmc: '', left_amount: 0 }] : configs['资金垫付']
                });
                const kms = configs.km;
                if (kms) setKmdata(kms.filter(it => it.km.toLowerCase().includes('ck')));
                form.setFieldValue("xxp_wk", configs.wkxxp);
            } finally {
                setIsloading(false);
            }
        }
        if (myItem) {
            setIsloading(true);

            form.setFieldsValue(myItem);
            form.setFieldValue('xs_dwn', `${myItem.xs_dw}-${myItem.xs_sh}`);
            setInvoiceId(myItem.id);
            webPost('getInvoiceConfig', { sn: myItem.sn, invoice_id: myItem.id }).then((res) => {
                if (res) {
                    setConfig({ ...res, jsfs: getJsfs() });
                    setMyHtv((prev) => ({ ...prev, ...res.flb }));
                    const lyb = res.ly;
                    setLycount(lyb.length);
                    const itm = {};
                    for (let index = 0, l = lyb.length; index < l; index++) {
                        itm[`zfly_${index}`] = lyb[index]['type'];
                        itm[`zfid_${index}`] = lyb[index]['cw_data_id'];
                        itm[`zfamt_${index}`] = lyb[index]['amount'];
                        itm[`zfacc_${index}`] = lyb[index]['bank_acc'];
                        itm[`zfzhid_${index}`] = lyb[index]['bank_id'];
                    }
                    form.setFieldsValue(itm);
                    setLydata({
                        '个人来款': [...res['个人来款'], { id: 0, make_date: '现付', kmmc: '现付', left_amount: 0 }], '建设单位来款': res['建设单位来款'],
                        '资金垫付': res['资金垫付'].length === 0 ? [{ id: 0, make_date: '资金垫付', kmmc: '', left_amount: 0 }] : res['资金垫付']
                    });
                    setIsloading(false);
                } else {
                    setMyHtv(null);
                }
            })

        } else {
            if (myHtv) {
                setXmsn(myHtv.htno);
                form.setFieldsValue({
                    ...myHtv, sn: myHtv.htno, ht_money: myHtv.totalmoney, xxp_yk: myHtv.xxk, mf_dw: myHtv.u2com, mf_sh: myHtv.u2tax, mf_khh: myHtv.u2kh,
                    mf_yhzh: myHtv.u2zh, mf_dwdz: myHtv.u2dz, mf_tel: myHtv.u2tel, ys_dz: myHtv.u2xmsw, km: 'LK012 实收税/管费', jz_xm_mc: myHtv.xmmc, jz_fw_fd: myHtv.u2dd,
                    ps2: '', ps: ''
                });

                getCs(myHtv.htno);
            }
            setInvoiceId(0);
        }
        return undefined;
    }, [myHt, myItem, fkey]);

    useEffect(() => {
        calcTotalSj();
    }, [lycount])
    const [kpj, setKpj] = useState(0);
    const [kpsl, setKpsl] = useState(0);
    const reCalMoney = () => {
        const total = Number(form.getFieldValue('amount'));
        setKpj(total);
        const _kpsl = form.getFieldValue('kpsl');
        setKpsl(_kpsl);
        
        let sjsl = 0;
        const val1 = Number(myHtv[`f${_kpsl}`]) || 0;
        const val2 = Number(myHtv[`glf${_kpsl}`]) || 0;
        const val3 = Number(myHtv[`yglf${_kpsl}`]) || 0;
        sjsl = val1 + val2 + val3;
        if (sjsl - _kpsl < 0) {
            message.error('当前税率未设置，请联系相关人员设置，当前无法提交');
        }
        form.setFieldValue('yssl', sjsl);
        form.setFieldValue('amount_sj', Math.round(total * sjsl) / 100);
        const _bhsje = Math.round(total * 10000 / (100 + Number(_kpsl))) / 100;
        form.setFieldValue('bhsje', _bhsje);
        form.setFieldValue('se', Math.round(_bhsje * _kpsl) / 100);
    }

    const loadingRef = useRef();
    const saveSubmit = async (sh) => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setIsloading(true);
        try {
            const values = await form.validateFields();
            console.log('校验通过', values, getobjkeys(values));
            if (values.yssl - values.kpsl < 0) {
                message.error('当前税率未设置，无法提交');
                return;
            }
            const total = Number(values.amount_sj);
            let tot = 0;
            for (let i = 0; i < lycount; i++) {
                tot += Number(values[`zfamt_${i}`]) || 0;
                if (!values[`zfzhid_${i}`]) {
                    const matched = config?.yhzh.find(it => Number(it.id) === Number(values[`zfzhid_${i}`]));
                    values[`zfacc_${i}`] = matched ? `${matched.dw}-${matched.mc}-${matched.zh}` : `未获取正确值`;
                }
            }
            if (Math.abs(total - tot) > 0.01) {
                message.error('实收税金与支付金额不符');
                return;
            }
            const id = invoice_id;
            const res = await webPost('invoicesave', {
                ...values, id: id, sh, lycount
            });
            if (res) {
                message.success('保存成功');
                form.resetFields();
                if (onSave) {
                    onSave();
                } else {
                    navigate('/htcx/' + values.sn);
                }
            }
        } catch (errorInfo) {
            console.log('校验失败', errorInfo);
            message.error('请检查表单填写内容，有必填项未填或格式错误！');
            const firstErrorItem = document.querySelector('.ant-form-item-has-error');

            if (firstErrorItem) {
                firstErrorItem.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
            }
        } finally {
            loadingRef.current = false;
            setIsloading(false);
        }
        return;
    };
    const getlydata = async (index) => {
        form.setFieldValue(`bank_id_${index}`, undefined);
        form.setFieldValue(`zfid_${index}`, undefined);
        form.setFieldValue(`zfzhid_${index}`, undefined);
        const lx = form.getFieldValue('zfly_' + index);
        setLyfkzh((prev) => ({ ...prev, [`b_${index}`]: lx }));
        setLyfresh(Math.random());
    }
    const setXsxx = () => {
        const v1 = form.getFieldValue('xs_dwn');
        if (v1 && config?.coms) {
            const it = config.coms.find((it) => v1 === `${it.name} - ${it.tax_no}`);
            if (it) {
                const item = { 'xs_dw': it.name, 'xs_sh': it.tax_no, 'xs_khh': it.khh, 'xs_yhzh': it.yhzh, 'xs_dwdz': it.dwdz, 'xs_tel': it.phone };
                form.setFieldsValue(item);
                return;
            }
        }
        form.setFieldsValue({ 'xs_dw': v1, 'xs_sh': '', 'xs_khh': '', 'xs_yhzh': '', 'xs_dwdz': '', 'xs_tel': '' });
    }
    const calcTotalSj = () => {
        let amt = 0;
        for (let i = 0; i < lycount; i++) {
            let a = Number(form.getFieldValue(`zfamt_${i}`)) || 0;
            amt += a;
        }
        setTotalsj(amt.toFixed(2));
    }
    return (
        <FullHeightLayout
            headerContent={null}
            footerContent={
                step === 0 ? (<Row justify="center" style={{ width: '90%' }}>
                    <Col>
                        <Button type="link" onClick={() => saveSubmit(0)}>保存为草稿</Button>
                        <Button onClick={() => saveSubmit(1)}>提交申请</Button>
                    </Col>
                </Row>) : (<Row justify="center" style={{ width: '90%' }}>
                    <Col>
                        <Button type="link" onClick={() => saveSubmit(0)}>下一步</Button>
                    </Col>
                </Row>)
            }
        >
            <Spin spinning={isloading}>
                <Form form={form} layout="vertical">
                    {step === 0 && (<>
                        <h3>业务明细</h3>
                        <div className='responsive-grid'>
                            <Form.Item className="form-item-bordered" label="项目编号" name="sn" rules={[{ required: true }]}><Input readOnly /></Form.Item>
                            <Form.Item className="form-item-bordered" label="项目名称" name="xmmc" rules={[{ required: true }]} ><Input readOnly /></Form.Item>
                            <Form.Item className="form-item-bordered" label="合同金额（人民币）" name="ht_money"><Input type="number" readOnly /></Form.Item>
                            <Form.Item className="form-item-bordered" label="计税方法" name="tax_type"><Select><Option value="一般计税">一般计税</Option><Option value="简易计税">简易计税</Option></Select></Form.Item>
                            <Form.Item className="form-item-bordered" label="累计已开票金额" name="xxp_yk"><Input type="number" readOnly /></Form.Item>
                            <Form.Item className="form-item-bordered" label="未开票金额" name="xxp_wk"><Input type="number" readOnly /></Form.Item>
                            <Form.Item className="form-item-bordered" label="是否异地预缴" name="is_yd" initialValue={0}>
                                <Radio.Group><Radio value={1}>是</Radio><Radio value={0}>否</Radio></Radio.Group></Form.Item>
                            <Form.Item className="form-item-bordered" label="是否预收款" name="is_ys" initialValue={0}><Radio.Group>
                                <Radio value={1}>是</Radio><Radio value={0}>否</Radio></Radio.Group></Form.Item>
                            <Form.Item className="form-item-bordered" label="含税金额" name="amount"><InputNumber style={{ width: '100%' }} onChange={reCalMoney} /></Form.Item>
                            <Form.Item className="form-item-bordered" label="开票税率" name="kpsl">
                                <Select onChange={reCalMoney}><Option value='3'>3%</Option><Option value='6'>6%</Option><Option value='9'>9%</Option><Option value='13'>13%</Option>
                                </Select>
                            </Form.Item>
                            <Form.Item className="form-item-bordered" label="应收税率" name="yssl" hidden><InputNumber style={{ width: '100%' }} /></Form.Item>
                            <Form.Item className="form-item-bordered" label="应收税款" name="amount_sj"><InputNumber style={{ width: '100%' }} /></Form.Item>

                            <Form.Item className="form-item-bordered" label="费用科目" name="km">
                                <Input value='LK012 实收税/管费' />
                            </Form.Item>
                            <Form.Item className="form-item-bordered" label="申请单号" name="isn">
                                <Input placeholder='系统生成，不需填写' readOnly />
                            </Form.Item>
                            <Form.Item className="form-item-bordered" label="备注" name="ps"><Input /></Form.Item>
                            <Form.Item className="form-item-bordered" label="制单日期" name="make_date" rules={[{ required: true }]}><DateInput /></Form.Item>
                        </div>
                        <div key='jsnjhj' style={{ textAlign: 'right', paddingRight: '12px' }}>当前税金合计：{totalsj}, 还需缴纳：
                            {(Number(form.getFieldValue('amount_sj')) - Number(totalsj)).toFixed(2)}</div>
                        {
                            Array.from({ length: lycount }, (_, index) => (
                                <Card key={`ifm_${index}`} title={<h4 style={{ color: 'red' }}>{`应收税金缴纳方式${1 + index}`}</h4>}>
                                    <div key={index} className='responsive-grid4'>
                                        <Form.Item label="应收税金缴纳方式" name={`zfly_${index}`} rules={[{ required: true }]}>
                                            <Select onChange={() => { getlydata(index) }}><Option value='个人来款'>个人来款</Option><Option value='建设单位来款'>建设单位来款</Option>
                                                <Option value='资金垫付'>资金垫付</Option>
                                            </Select>
                                        </Form.Item>
                                        <Form.Item label="来源对象" name={`zfid_${index}`} rules={[{ required: true }]}>
                                            <Select onChange={v => {
                                                let fkid = undefined;
                                                let fkItem = null;
                                                lydata[form.getFieldValue(`zfly_${index}`)]?.map((it) => {
                                                    if (Number(it.id) === Number(v)) {
                                                        fkid = it.bank_id;
                                                        fkItem = it;
                                                        if (fkItem.kmmc === '现付') {
                                                            setShowFile1(true);
                                                        } else {
                                                            setShowFile1(false);
                                                        }
                                                        if (it.left_amount > 0) {
                                                            form.setFieldValue(`zfmaxamt_${index}`, it.left_amount);
                                                        } else {
                                                            form.setFieldValue(`zfmaxamt_${index}`, 0);
                                                        }
                                                    }
                                                });
                                                form.setFieldValue(`zfzhid_${index}`, fkid);

                                            }}

                                            >{
                                                    lyfresh && lydata[form.getFieldValue(`zfly_${index}`)] && (
                                                        lydata[form.getFieldValue(`zfly_${index}`)].length > 0 ?
                                                            lydata[form.getFieldValue(`zfly_${index}`)]?.map((it) => {
                                                                return <Option value={it.id}><span>{`${it.make_date}-${it.kmmc}-`}</span>
                                                                    <span style={{ color: it.left_amount < 0 ? 'red' : '#000' }}>{`${it.left_amount}`}</span></Option>
                                                            }) :
                                                            <Option>--无数据--</Option>
                                                    )
                                                }</Select>
                                        </Form.Item>
                                        <Form.Item label="支付金额" name={`zfamt_${index}`} rules={[{ required: true }]}>
                                            <InputNumber type="number" style={{ width: '100%' }} onChange={(v) => {
                                                const mx = Number(form.getFieldValue(`zfmaxamt_${index}`)) || 0;
                                                if (mx > 0) {
                                                    if (v - mx > 0) {
                                                        message.error('不能超出来源总额');
                                                        form.setFieldValue(`zfamt_${index}`, mx);
                                                    }
                                                }
                                                calcTotalSj();
                                            }} />
                                        </Form.Item>
                                        <Form.Item name={`zfmaxamt_${index}`} hidden><Input /></Form.Item>
                                        <Form.Item name={`zfacc_${index}`} hidden><Input /></Form.Item>
                                        <Form.Item label="付款账户" name={`zfzhid_${index}`} rules={[{ required: true }]}>
                                            <Select disabled={lyfkzh[`b_${index}`] !== '资金垫付'} placeholder="选择付款账户" onChange={(value) => {
                                                const matched = config?.yhzh.find(it => Number(it.id) === Number(value));
                                                if (matched) {
                                                    form.setFieldsValue({ [`zfacc_${index}`]: `${matched.dw}-${matched.mc}-${matched.zh}` });
                                                } else {
                                                    form.setFieldsValue({ [`zfacc_${index}`]: `未设置` });
                                                }
                                            }}>{config?.yhzh && config.yhzh.map(it => {
                                                return <Option key={it.id} value={it.id}>{`${it.dw}-${it.mc}-${it.zh}`}</Option>
                                            })}</Select>
                                        </Form.Item>
                                    </div>
                                </Card>
                            ))
                        }
                        <div className='responsive-grid'>
                            <Form.Item label={<a onClick={() => { setLycount(prev => (1 + prev)); }}>增加支付来源</a>} ></Form.Item>
                            <Form.Item label={<a onClick={() => { setLycount(prev => (Math.max(prev - 1, 1))); }}>支付来源-1</a>} ></Form.Item>
                        </div>
                        <h3>发票销售方信息</h3>
                        <div className='responsive-grid'>
                            <Form.Item className="form-item-bordered" label="单位名称" name="xs_dwn" rules={[{ required: true }]}>
                                <AutoComplete options={config?.coms && config.coms.map((it) => ({ value: `${it.name} - ${it.tax_no}` }))} onChange={setXsxx} />
                            </Form.Item>
                            <Form.Item label="单位名称" name="xs_dw" hidden><Input /></Form.Item>
                            <Form.Item className="form-item-bordered" label="税号" name="xs_sh" rules={[{ required: true }]} ><Input /></Form.Item>
                            <Form.Item className="form-item-bordered" label="开户银行" name="xs_khh"><Input /></Form.Item>
                            <Form.Item className="form-item-bordered" label="银行账号" name="xs_yhzh"><Input /></Form.Item>
                            <Form.Item className="form-item-bordered" label="单位地址" name="xs_dwdz"><Input /></Form.Item>
                            <Form.Item className="form-item-bordered" label="电话" name="xs_tel"><Input /></Form.Item>
                            <Form.Item className="form-item-bordered" label="是否展示销售方银行账号标签" name="xs_zs_yhzh" initialValue={0}>
                                <Radio.Group><Radio value={1}>是</Radio><Radio value={0}>否</Radio></Radio.Group>
                            </Form.Item>
                            <Form.Item className="form-item-bordered" label="是否展示销售方地址电话标签" name="xs_zs_dwdz" initialValue={0}>
                                <Radio.Group><Radio value={1}>是</Radio><Radio value={0}>否</Radio></Radio.Group>
                            </Form.Item>
                        </div>
                        <h3>发票购买方信息</h3>
                        <div className='responsive-grid'>
                            <Form.Item className="form-item-bordered" label="单位名称" name="mf_dw" rules={[{ required: true }]}><Input /></Form.Item>
                            <Form.Item className="form-item-bordered" label="税号" name="mf_sh" rules={[{ required: true }]} ><Input /></Form.Item>
                            <Form.Item className="form-item-bordered" label="开户银行" name="mf_khh"><Input /></Form.Item>
                            <Form.Item className="form-item-bordered" label="银行账号" name="mf_yhzh"><Input /></Form.Item>
                            <Form.Item className="form-item-bordered" label="单位地址" name="mf_dwdz"><Input /></Form.Item>
                            <Form.Item className="form-item-bordered" label="电话" name="mf_tel"><Input /></Form.Item>
                            <Form.Item className="form-item-bordered" label="是否展示销售方银行账号标签" name="mf_zs_yhzh" initialValue={0}>
                                <Radio.Group><Radio value={1}>是</Radio><Radio value={0}>否</Radio></Radio.Group>
                            </Form.Item>
                            <Form.Item className="form-item-bordered" label="是否展示销售方地址电话标签" name="mf_zs_dwdz" initialValue={0}>
                                <Radio.Group><Radio value={1}>是</Radio><Radio value={0}>否</Radio></Radio.Group>
                            </Form.Item>
                        </div>
                        <h3>特定要素</h3>
                        <div className='responsive-grid4'>
                            <Form.Item className="form-item-bordered" label="房地产开发" name="is_fdc" initialValue={0}>
                                <Radio.Group><Radio value={1}>是</Radio><Radio value={0}>否</Radio></Radio.Group>
                            </Form.Item>
                            <Form.Item className="form-item-bordered" label="应税行为发生地/项目地点" name="ys_dz"><Input /></Form.Item>
                            <Form.Item className="form-item-bordered" label="土地增值税项目编号" name="zzs_sn"><Input /></Form.Item>
                            <Form.Item className="form-item-bordered" label="跨地（市） 标志" name="mark_ds" initialValue={0}>
                                <Radio.Group><Radio value={1}>是</Radio><Radio value={0}>否</Radio></Radio.Group>
                            </Form.Item>
                        </div>
                        <h3>明细</h3>
                        <div className='responsive-grid4'>
                            <Form.Item className="form-item-bordered" label="商品" name="spmc" rules={[{ required: true }]}><Input /></Form.Item>
                            <Form.Item className="form-item-bordered" label="税收分类简称" name="shui_shou_jian_cheng"><Input /></Form.Item>
                            <Form.Item className="form-item-bordered" label="发票类型" name="fp_type" initialValue={1}><Select>
                                <Option value={1}>电子专票</Option><Option value={2}>普票</Option>
                            </Select></Form.Item>
                            <Form.Item className="form-item-bordered" label="开票税率" name="kp_slv">{kpsl}%</Form.Item>

                            <Form.Item className="form-item-bordered" label="商品数量" name="sp_sl"><InputNumber style={{ width: '100%' }} min={1} /></Form.Item>
                            <Form.Item className="form-item-bordered" label="单价" name="sp_dj"><InputNumber style={{ width: '100%' }} /></Form.Item>
                            <Form.Item className="form-item-bordered" label="不含税金额" name="bhsje"><InputNumber style={{ width: '100%' }} /></Form.Item>

                            <Form.Item className="form-item-bordered" label="税额" name="se"><InputNumber style={{ width: '100%' }} /></Form.Item>
                            <Form.Item className="form-item-bordered" label="含税金额">{kpj}</Form.Item>
                            <Form.Item className="form-item-bordered" label="建筑项目名称" name="jz_xm_mc"><Input style={{ width: '100%' }} /></Form.Item>
                            <Form.Item className="form-item-bordered" label="建筑服务发生地" name="jz_fw_fd"><Input style={{ width: '100%' }} /></Form.Item>



                        </div>
                        <div className='responsive-grid2'>
                            <Form.Item className="form-item-bordered" label="备注" name="ps2"><Input.TextArea rows={7} /></Form.Item>
                            {showFile1 && <Form.Item className="form-item-bordered" label="付款凭据" name="files1"><ImgUploader /></Form.Item>}
                        </div>
                    </>)}
                    {step === 1 && (<>


                    </>)}



                </Form >
            </Spin>
        </FullHeightLayout >
    );
};

export default InvoiceForm;